// Google My Business navigation, in the same shape as the main app's workspaceNav.js.

const starts = (...prefixes) => (pathname) => prefixes.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));

export const NAV_GROUPS = [
  {
    id: 'daily',
    items: [
      { id: 'home', label: 'Home', to: '/home', icon: 'home', match: starts('/home') },
      { id: 'reviews', label: 'Reviews', to: '/reviews', icon: 'reviews', badge: 'waiting', match: starts('/reviews') },
      { id: 'posts', label: 'Posts', to: '/posts', icon: 'posts', badge: 'scheduled_posts', soft: true, match: starts('/posts') },
    ],
  },
  {
    id: 'profile',
    label: 'Profile',
    items: [
      { id: 'profile', label: 'Business profile', to: '/profile', icon: 'profile', match: starts('/profile') },
      { id: 'insights', label: 'Insights', to: '/insights', icon: 'insights', match: starts('/insights') },
    ],
  },
  {
    id: 'grow',
    label: 'Grow',
    items: [
      { id: 'seo', label: 'Local SEO', to: '/seo', icon: 'seo', match: starts('/seo') },
      { id: 'get-reviews', label: 'Get reviews', to: '/get-reviews', icon: 'getReviews', match: starts('/get-reviews') },
      { id: 'auto-reply', label: 'Auto-replies', to: '/auto-reply', icon: 'autoReply', badge: 'rules_on', soft: true, match: starts('/auto-reply') },
    ],
  },
];

export const FOOTER_ITEMS = [
  { id: 'activity', label: 'Activity', to: '/activity', icon: 'activity', match: starts('/activity') },
  { id: 'settings', label: 'Settings', to: '/settings', icon: 'settings', match: starts('/settings') },
  { id: 'guide', label: 'Guide', to: '/guide', icon: 'guide', match: starts('/guide') },
];

export function activeItemId(pathname) {
  for (const group of NAV_GROUPS) {
    const found = group.items.find((item) => item.match(pathname));
    if (found) return found.id;
  }
  return FOOTER_ITEMS.find((item) => item.match(pathname))?.id || null;
}

// Product switcher tones, shared with the other Auto Appy products.
export const PRODUCT_TONES = { main: '#147DB5', whatsapp: '#1F9D57', crm: '#183F5A', ai: '#37A1D2', meta: '#1A8CCB', gmb: '#1F8A70' };
const isAi = (app) => /(^|[-_\s])ai($|[-_\s])/i.test(String(app?.key || '')) || /\bAI\b/.test(String(app?.name || ''));
const isMeta = (app) => /meta/i.test(String(app?.key || '')) || /meta ads/i.test(String(app?.name || ''));
const isGmb = (app) => /google-my-business|gmb/i.test(String(app?.key || '')) || /google (my )?business/i.test(String(app?.name || ''));
export const productTone = (app) => PRODUCT_TONES[app?.key] || (isGmb(app) ? PRODUCT_TONES.gmb : isMeta(app) ? PRODUCT_TONES.meta : isAi(app) ? PRODUCT_TONES.ai : '#3A5264');
const MARKS = { main: 'AA', whatsapp: 'WA', crm: 'CRM' };
export function productMark(app) {
  if (MARKS[app?.key]) return MARKS[app.key];
  if (isGmb(app)) return 'GMB';
  if (isMeta(app)) return 'ADS';
  if (isAi(app)) return 'AI';
  const rest = String(app?.name || '').replace(/^auto\s*appy\s*/i, '').trim();
  return (rest.split(/\s+/).filter(Boolean).map((part) => part[0]).join('').slice(0, 2) || 'AA').toUpperCase();
}
